// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AI Test Case Generation Modal Styles */

.ai-test-case-modal {
  max-width: 800px;
  width: 90%;
  max-height: 90vh;
}

.requirement-info {
  background-color: #f9fafb;
  border-radius: 0.5rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
  border: 1px solid #e5e7eb;
}

.info-item {
  margin-bottom: 0.5rem;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-label {
  font-weight: 600;
  color: #4b5563;
  margin-right: 0.5rem;
}

.info-value {
  color: #1f2937;
}

.generation-progress {
  text-align: center;
  padding: 2rem 0;
}

.generation-progress h3 {
  margin-bottom: 1.5rem;
  color: #4b5563;
}

.progress-bar-container {
  height: 0.5rem;
  background-color: #e5e7eb;
  border-radius: 9999px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.progress-bar-fill {
  height: 100%;
  background-color: #3b82f6;
  border-radius: 9999px;
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 1.5rem;
}

.ai-animation {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.ai-thinking {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  border: 3px solid rgba(59, 130, 246, 0.3);
  border-top-color: #3b82f6;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.generated-test-cases {
  margin-top: 1rem;
}

.generated-test-cases h3 {
  margin-bottom: 1rem;
  color: #1f2937;
  font-size: 1.25rem;
}

.test-cases-list {
  /* max-height: 400px; */
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
}

.test-case-item {
  padding: 1rem;
  border-bottom: 1px solid #e5e7eb;
}

.test-case-item:last-child {
  border-bottom: none;
}

.test-case-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.test-case-header h4 {
  margin: 0;
  font-size: 1rem;
  color: #1f2937;
}

.priority-badge {
  font-size: 0.75rem;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
}

.priority-badge.high {
  background-color: #fee2e2;
  color: #991b1b;
}

.priority-badge.medium {
  background-color: #fef3c7;
  color: #92400e;
}

.priority-badge.low {
  background-color: #d1fae5;
  color: #065f46;
}

.test-case-details {
  font-size: 0.875rem;
}

.detail-section {
  margin-bottom: 0.75rem;
}

.detail-section h5 {
  margin: 0 0 0.25rem 0;
  font-size: 0.875rem;
  color: #4b5563;
}

.detail-section pre {
  margin: 0;
  white-space: pre-wrap;
  font-family: inherit;
  color: #6b7280;
  background-color: #f9fafb;
  padding: 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.8125rem;
}

.error-message {
  background-color: #fee2e2;
  color: #991b1b;
  padding: 1rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
}

/* Button styles */
.primary-button {
  background-color: #3b82f6;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.primary-button:hover:not(:disabled) {
  background-color: #2563eb;
}

.primary-button:disabled {
  background-color: #93c5fd;
  cursor: not-allowed;
}

.secondary-button {
  background-color: white;
  color: #4b5563;
  border: 1px solid #d1d5db;
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.secondary-button:hover {
  background-color: #f9fafb;
}`, "",{"version":3,"sources":["webpack://./src/styles/ai-test-case-modal.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* AI Test Case Generation Modal Styles */\n\n.ai-test-case-modal {\n  max-width: 800px;\n  width: 90%;\n  max-height: 90vh;\n}\n\n.requirement-info {\n  background-color: #f9fafb;\n  border-radius: 0.5rem;\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n  border: 1px solid #e5e7eb;\n}\n\n.info-item {\n  margin-bottom: 0.5rem;\n}\n\n.info-item:last-child {\n  margin-bottom: 0;\n}\n\n.info-label {\n  font-weight: 600;\n  color: #4b5563;\n  margin-right: 0.5rem;\n}\n\n.info-value {\n  color: #1f2937;\n}\n\n.generation-progress {\n  text-align: center;\n  padding: 2rem 0;\n}\n\n.generation-progress h3 {\n  margin-bottom: 1.5rem;\n  color: #4b5563;\n}\n\n.progress-bar-container {\n  height: 0.5rem;\n  background-color: #e5e7eb;\n  border-radius: 9999px;\n  overflow: hidden;\n  margin-bottom: 0.5rem;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background-color: #3b82f6;\n  border-radius: 9999px;\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  font-size: 0.875rem;\n  color: #6b7280;\n  margin-bottom: 1.5rem;\n}\n\n.ai-animation {\n  display: flex;\n  justify-content: center;\n  margin-top: 2rem;\n}\n\n.ai-thinking {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 50%;\n  border: 3px solid rgba(59, 130, 246, 0.3);\n  border-top-color: #3b82f6;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.generated-test-cases {\n  margin-top: 1rem;\n}\n\n.generated-test-cases h3 {\n  margin-bottom: 1rem;\n  color: #1f2937;\n  font-size: 1.25rem;\n}\n\n.test-cases-list {\n  /* max-height: 400px; */\n  overflow-y: auto;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.5rem;\n}\n\n.test-case-item {\n  padding: 1rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.test-case-item:last-child {\n  border-bottom: none;\n}\n\n.test-case-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.test-case-header h4 {\n  margin: 0;\n  font-size: 1rem;\n  color: #1f2937;\n}\n\n.priority-badge {\n  font-size: 0.75rem;\n  font-weight: 600;\n  padding: 0.25rem 0.5rem;\n  border-radius: 9999px;\n}\n\n.priority-badge.high {\n  background-color: #fee2e2;\n  color: #991b1b;\n}\n\n.priority-badge.medium {\n  background-color: #fef3c7;\n  color: #92400e;\n}\n\n.priority-badge.low {\n  background-color: #d1fae5;\n  color: #065f46;\n}\n\n.test-case-details {\n  font-size: 0.875rem;\n}\n\n.detail-section {\n  margin-bottom: 0.75rem;\n}\n\n.detail-section h5 {\n  margin: 0 0 0.25rem 0;\n  font-size: 0.875rem;\n  color: #4b5563;\n}\n\n.detail-section pre {\n  margin: 0;\n  white-space: pre-wrap;\n  font-family: inherit;\n  color: #6b7280;\n  background-color: #f9fafb;\n  padding: 0.5rem;\n  border-radius: 0.25rem;\n  font-size: 0.8125rem;\n}\n\n.error-message {\n  background-color: #fee2e2;\n  color: #991b1b;\n  padding: 1rem;\n  border-radius: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n/* Button styles */\n.primary-button {\n  background-color: #3b82f6;\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.primary-button:hover:not(:disabled) {\n  background-color: #2563eb;\n}\n\n.primary-button:disabled {\n  background-color: #93c5fd;\n  cursor: not-allowed;\n}\n\n.secondary-button {\n  background-color: white;\n  color: #4b5563;\n  border: 1px solid #d1d5db;\n  padding: 0.5rem 1rem;\n  border-radius: 0.375rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.secondary-button:hover {\n  background-color: #f9fafb;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
